// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__1cXSo","tooltipWpapper":"Tooltip_tooltipWpapper__3IaAy"};